var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "list-view"
  }, [_c('div', {
    class: {
      'list-view__multiple': _vm.multiCol
    },
    style: _vm.renderedListStyle
  }, [_vm.formatedData.length > 0 || _vm.plugins ? _vm._l(_vm.formatedData, function (item, index) {
    return _c('div', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: _vm.loading,
        expression: "loading"
      }],
      key: index,
      staticClass: "list-view__item",
      style: _vm.cardStyle
    }, [_vm.selection ? _c('el-checkbox', {
      staticClass: "list-view__item__check",
      attrs: {
        "value": _vm.checked[index]
      },
      on: {
        "input": function ($event) {
          return _vm.handleCheck($event, item, index);
        }
      }
    }) : _vm._e(), _vm._t("card", function () {
      return [_c('Card', {
        staticClass: "list-view__item__card",
        attrs: {
          "data": item,
          "multi-col": _vm.multiCol,
          "title-style": _vm.titleStyle
        },
        on: {
          "click": function ($event) {
            return _vm.handleClick(item, index, $event);
          }
        }
      }, [_c('template', {
        slot: "image-box"
      }, [_vm._t("card-image", null, {
        "card": item
      })], 2), _c('template', {
        slot: "header-right"
      }, [_vm._t("card-header", null, {
        "card": item
      })], 2), _c('template', {
        slot: "body"
      }, [_vm._t("card-body", null, {
        "card": item
      })], 2)], 2)];
    }, {
      "card": item
    })], 2);
  }) : _c('div', {
    staticClass: "list-view__empty-block"
  }, [_c('span', {
    staticClass: "list-view__empty-text"
  }, [_vm._v(_vm._s(_vm.emptyText))])])], 2), _vm.pager ? _c('el-pagination', _vm._b({
    staticClass: "pager",
    on: {
      "size-change": _vm.hanlePageSizeChange,
      "current-change": _vm.hanlePageCurrentChange
    }
  }, 'el-pagination', _vm.pager, false)) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };